// extracted by mini-css-extract-plugin
export default {"table-cell":"TableSkeleton_table-cell__JIb3x","tr":"TableSkeleton_tr__4wqQE","table-row":"TableSkeleton_table-row__ztC7v"};